export default {
  product: {
    name: 'Cadeaubon kopen',
  },
  description: {
    items: {
      delivery: 'Direct per e-mail verzonden als PDF',
      usage: {
        online: 'Alleen online inwisselbaar',
        online_and_store: 'Online en in het restaurant inwisselbaar',
      },
      value: 'Flexibele bedragen van {{from}} tot {{to}}',
    },
  },
};
